function RTEImageList(images) {
  if (!(images instanceof Array)) {
    throw new Error('Images must be an array');
  }
  if (images.some((item) => !(item instanceof File) && (item?.index === undefined || item?.index === null))) {
    throw new Error('Image object must have an index or be of type File');
  }

  let list = [];
  let lastIndex = images.reduce((acc, cur) => (cur.index > acc ? cur.index : acc), -1);

  list = images.reduce((acc, item) => {
    if (item.url) {
      acc.push({
        index: item.index,
        image: item,
      });
    } else {
      lastIndex += 1;
      acc.push({
        index: lastIndex,
        image: item,
      });
    }

    return acc;
  }, []);

  for (let i = 0; i < list.length; i += 1) {
    if (
      (list[i].image instanceof File
      || typeof list[i].image === 'object')
      && ![null, undefined].includes(list[i].index)
    ) {
      this[i] = list[i];
    } else {
      throw new Error('Invalid image object');
    }
  }
}

RTEImageList.prototype = {
  getItemList() {
    return Object.values(this).reduce((acc, item) => {
      if (item.image.url) {
        acc.push({
          label: item.image.name,
          url: item.image.url,
          value: item.index,
        });
      } else {
        acc.push({
          label: item.image.name,
          url: URL.createObjectURL(item.image),
          value: item.index,
        });
      }

      return acc;
    }, []);
  },
  getImages() {
    const invalidImages = Object.values(this).filter((item) => !(item.image instanceof File));
    const validImages = Object.values(this).filter((item) => item.image instanceof File);
    const lastIndex = invalidImages.reduce((acc, cur) => (cur.index > acc ? cur.index : acc), -1);
    const images = Array.from({ length: lastIndex + 1 }, () => new File([], ''));

    validImages.forEach((item) => {
      images.push(item.image);
    });

    return images;
  },
};

Object.defineProperty(RTEImageList.prototype, 'length', {
  get() {
    return Object.keys(this).length;
  },
});

export default RTEImageList;
